
import { Vue, Component, Watch, Prop } from "vue-property-decorator";

@Component
export default class PassCodeVerifyForm extends Vue {

	@Prop()
	title;

	@Prop()
	btnText;

	passCode = '';

	cells = []

	queryForm: {
		passCodeId?: string;
		mobile?: string;
		idNo?: string;
	} = {};

	// 錯誤提示訊息
  customErrorMsg: { [key: string]: string} = {
    passCode: null,
  }

  // 改變pinCode下方底線顏色
  changePinCodeValidStatus(status, validPlace: 'f2eError' | 'serverError' = 'f2eError') {
    const validStatus = {
      success: '#4CAAF5',
      error: '#F5222D',
      none: '#e8e8e8'
    }

    // 待 DOM 加載完再遍歷欄位值
    this.$nextTick(()=> {
      for(let i=0; i<this.cells.length; i++) {
        this.cells[i].style.borderBottom = (this.cells[i].value && validPlace === 'f2eError')
          ? `2px solid ${validStatus.success}`
          : `2px solid ${validStatus[status]}`;
      }
    })
  }

	// 前端檢核驗證碼
  checkPassCode() {
    if(this.passCode.length === this.cells.length) {
      this.customErrorMsg.passCode = null
      return
    }

    this.changePinCodeValidStatus('error')
    this.customErrorMsg.passCode = '請輸入完整之驗證碼'
  }


	handleResendPassCode() {
		this.$emit('resendPassCode');
	}

	handleNextStep() {
		this.checkPassCode();
		if (!this.customErrorMsg.passCode) {
			this.$emit('onSubmitPassCode', this.passCode);
		}
	}

	created() {
		this.$nextTick(()=> {
      const wrapper = (this.$refs.pincode as any)?.$el;
			var pincodeDom = wrapper.getElementsByClassName('vue-pincode-input');
      this.cells = pincodeDom;
    })
	}

	@Watch('passCode')
  onCodeChange(val) {
    this.changePinCodeValidStatus('none')

    if(val.length > 0) {
      this.customErrorMsg.passCode = null
    }

		// 解決 ios 在 webView 上 自動填入觸發兩次問題
		if(this.passCode.length === this.cells.length) {
			this.$nextTick(()=> {
				this.cells[this.cells.length-1].blur();
			})
    }
  }

}
